export function AboutContent() {
  return (
    <div className="prose prose-lg max-w-4xl w-full">
      <h1>About 206mp</h1>

      <h2>Our Mission</h2>
      <p>
        206mp (206 Megapixels) is a photo community platform dedicated to thoughtful critique and
        beautiful collection creation. We believe in the power of constructive feedback and
        curated presentation to help photographers grow and showcase their work.
      </p>

      <h2>The Team</h2>
      <p>
        206mp is created and maintained by two software engineers with a passion for photography,
        based in the greater Seattle area:
      </p>

      <div className="not-prose bg-surface-1 rounded-lg p-6 my-6 border border-border">
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-1">Chris Anderson</h3>
            <p className="text-muted">
              <a href="mailto:chris@206mp.com" className="text-primary hover:underline">
                chris@206mp.com
              </a>
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-1">Josh Williams</h3>
            <p className="text-muted">
              <a href="mailto:jrw@206mp.com" className="text-primary hover:underline">
                jrw@206mp.com
              </a>
            </p>
          </div>
        </div>
      </div>

      <h2>Why "206mp"?</h2>
      <p>
        The name combines Seattle's iconic area code (206) with "megapixels" (mp), representing
        both our Pacific Northwest roots and our focus on high-quality photography.
      </p>

      <h2>Platform Features</h2>
      <ul>
        <li>
          <strong>Rich Critique System:</strong> Provide detailed feedback with editing suggestions
          and visual annotations
        </li>
        <li>
          <strong>Collection Publishing:</strong> Create magazine-style collections with curated
          photos and thoughtful layouts
        </li>
        <li>
          <strong>High-Resolution Support:</strong> Upload and view photos in full detail with
          advanced zoom capabilities
        </li>
        <li>
          <strong>Professional Metadata:</strong> Complete EXIF data display including camera
          settings, equipment, and technical details
        </li>
        <li>
          <strong>Modern Interface:</strong> Clean, responsive design that works beautifully across
          devices
        </li>
      </ul>

      <h2>Development Status</h2>
      <p>
        206mp is actively under development. We're continuously adding new features and improving
        the platform based on user feedback. If you encounter issues or have suggestions, we'd love
        to hear from you!
      </p>

      <h2>Technology</h2>
      <p>
        Built with modern web technologies including React, TypeScript, PostgreSQL, and a
        microservices architecture designed for reliability and scalability.
      </p>

      <h2>Contact Us</h2>
      <p>
        For general inquiries, support requests, or feedback, please reach out to us at:
      </p>
      <p className="ml-4">
        <strong>Email:</strong>{' '}
        <a href="mailto:admin@206mp.com" className="text-primary hover:underline">
          admin@206mp.com
        </a>
      </p>
      <p>We typically respond within 1-2 business days.</p>

      <hr className="my-8" />

      <p className="text-sm text-muted">
        Thank you for being part of the 206mp community. We're excited to see what you create!
      </p>
    </div>
  );
}
